import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure81 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        gridLineWidth: 2,
        max: 100000,
        min: 0,
        tickInterval: 50000,
        title: {
            text: "",
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ 
        
    {
        marker: {
            enabled: false
        },
        name: 'Australie et Nouvelle-Zélande',
        type: 'line',
        color: '#5b9bd6',
        zoneAxis: 'x',
        data: [
	       296, 342, 392, 468, 543, 624, 700, 742, 764, 775, 821
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Asie centrale et Asie du Sud',
        type: 'line',
        color: '#ed7e31',
        zoneAxis: 'x',
        data: [
	       7258, 8778, 10213, 12011, 13684, 15036, 16177, 17453, 18076, 18497, 18689
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Asie de l’Est et Asie du Sud-Est',
        type: 'line',
        color: '#a6a5a4',
        zoneAxis: 'x',
        data: [
	       2839, 3406, 4098, 4757, 5286, 5837, 6291, 6641, 6920, 7252, 7440
         ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Amérique latine et Caraïbes',
        type: 'line',
        color: '#ffbf00',
        zoneAxis: 'x',
        data: [
	       4528, 5391, 6230, 6893, 7647, 8251, 8865, 9543, 9940, 10116, 10149
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Afrique du Nord',
        type: 'line',
        color: '#4372c4',
        zoneAxis: 'x',
        data: [2564, 2967, 3348, 3665, 3841, 3978, 4089, 4209, 4303, 4370, 4375
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)',
        type: 'line',
        color: '#71ad49',
        zoneAxis: 'x',
        data: [
	       32, 61, 70, 88, 100, 105, 114, 122, 128, 142, 156         
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Afrique subsaharienne',
        type: 'line',
        color: '#265e91',
        zoneAxis: 'x',
        data: [
	       3177, 3814, 4576, 5290, 6208, 7173, 8066, 8796, 9455, 9758, 9881
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Asie de l’Ouest',
        type: 'line',
        color: '#9e480e',
        zoneAxis: 'x',
        data: [
	       2823, 3316, 3829, 4394, 4660, 4915, 5149, 5389, 5560, 5641, 5656
        ],
    },
    {
	    marker: {
	    enabled: false
		    },
		    name: 'Europe et Amérique du Nord',
		    type: 'line',
		    color: '#636363',
		    zoneAxis: 'x',
		    data: [
			   10266, 12698, 15173, 18000, 20748, 22694, 24443, 26208, 27466, 30789, 34185
			  ],
    },
    {
	    marker: {
			    enabled: false
		    },
		    name: 'Monde',
		    type: 'line',
		    color: '#9b7200',
		    zoneAxis: 'x',
		    data: [
			   33783, 40773, 47929, 55566, 62717, 68613, 73894, 79103, 82612, 87340, 91352
			  ],
    },	     
  ],

}